<template>
	<div class="app--engagement-auth-web-signup">
		<form novalidate ref="signup" @submit.prevent="signup($event)">
			<div v-if="!response.title" class="message text--color-default">{{ trans('auth.signup_message') }}</div>
			<div v-if="response.title" class="alert alert-dismissible" :class="response.class">
				<strong>{{ trans(response.title) }}</strong>
				<p v-if="response.description">{{ trans(response.description) }}</p>
				<button type="button" class="btn-close" @click="_response(null)"></button>
			</div>
			<div class="row gx-2">
				<div class="form-group col-md-6 col-12">
					<div class="input-group">
						<span class="input-group-text" :class="classes('input')"><app-icon
							value="user"></app-icon></span>
						<input type="text" autocomplete="off" class="form-control" required maxlength="32"
							   :class="classes('input')" v-model="field.first_name"
							   :placeholder="trans('auth.first_name')"/>

					</div>
					<div class="invalid-feedback"></div>
				</div>
				<div class="form-group col-md-6 col-12">
					<div class="input-group">
						<span class="input-group-text" :class="classes('input')"><app-icon
							value="user"></app-icon></span>
						<input type="text" autocomplete="off" class="form-control" required maxlength="32"
							   :class="classes('input')" v-model="field.last_name"
							   :placeholder="trans('auth.last_name')"/>

					</div>
					<div class="invalid-feedback"></div>
				</div>
			</div>
			<div class="row gx-2">
				<div class="form-group col-12">
					<div class="input-group">
						<span class="input-group-text" :class="classes('input')"><app-icon
							value="email"></app-icon></span>
						<input type="email" autocomplete="off" class="form-control" required :class="classes('input')"
							   v-model="field.email"
							   :placeholder="trans('auth.email').charAt(0).toUpperCase() + trans('auth.email').slice(1)"/>

					</div>
					<div class="invalid-feedback"></div>
				</div>
				<div class="form-group col-12">
					<field-phone v-model:value="field.phone" :classes="classes('input')" :default-country="country"
								 :validate-required="false" :allow-ext="false"
								 :placeholder="trans('auth.phone_number').charAt(0).toUpperCase() + trans('auth.phone_number').slice(1)"></field-phone>
				</div>
			</div>
			<div class="row gx-2">
				<div class="form-group col-md-6 col-12">
					<field-password v-model:value="field.password" :placeholder="trans('auth.password')"
									:classes="classes('input')" :validate-minlength="security.minlength"
									:validate-strength="security.strength" :validate-uppercase="security.r_uppercase"
									:validate-lowercase="security.r_lowercase" :validate-number="security.r_number"
									:validate-symbol="security.r_symbol">
						<template v-slot:prepend>
                            <span class="input-group-text" :class="classes('input')"><app-icon
								value="lock"></app-icon></span>
						</template>
					</field-password>
				</div>
				<div class="form-group col-md-6 col-12">
					<field-password v-model:value="field.password_confirmation" :classes="classes('input')"
									:placeholder="trans('auth.password_confirm')" :validate-confirm="field.password"
									:validate-minlength="0" :validate-strength="false">
						<template v-slot:prepend>
                            <span class="input-group-text" :class="classes('input')"><app-icon
								value="lock"></app-icon></span>
						</template>
					</field-password>
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-between">
				<app-button class="app--button border--button primary" type="submit" :loading="loading"
							:label="trans('buttons.signup')"></app-button>
				<app-button class="app--button border--button muted" :disabled="loading"
							:label="trans('buttons.cancel')"
							@click.native="cancel"></app-button>
			</div>
			<div class="d-flex align-items-center justify-content-start mt-3">
				<div class="text--color-default me-1">{{ trans('auth.signin') }}</div>
				<a href="javascript:void(0)" class="pfp-engagement-link m-0" @click="signin">
					<span class="text--size-lead">{{ trans('auth.signin_button') }}</span>
				</a>
			</div>
			
		</form>
	</div>
</template>

<script>
import store from '../../../store'
import Phone from '../../../../components/Phone'
import Password from '../../../../components/Password'

export default {
	props: {
		pages: {type: Array, required: true}
	},
	computed: {
		response() {
			let response = store.state.auth.response
			if (response && response.title && response.class && response.class == 'alert-danger') {
				response.title = this.trans(response.title)
				response.description = response.description ? this.trans(response.description) : ''
			}
			return response
		},
		country() {
			return store.getters.country
		},
		member() {
			return store.state.members.find(m => m.active == true)
		},
		canSignup() {
			return store.state.signup == true && store.state.security == 'HIGH'
		},
		security() {
			return {
				'minlength': parseInt(store.getters['security']('account_password_min_length')),
				'strength': store.getters['security']('account_password_zxcvbnjs') === '1',
				'r_uppercase': store.getters['security']('account_password_rule_uppercase') === '1',
				'r_lowercase': store.getters['security']('account_password_rule_lowercase') === '1',
				'r_number': store.getters['security']('account_password_rule_number') === '1',
				'r_symbol': store.getters['security']('account_password_rule_symbol') === '1',
			}
		}
	},
	data() {
		return {
			loading: false,
			field: {
				first_name: '',
				last_name: '',
				email: '',
				phone: {code: '', number: '', country: ''},
				password: '',
				password_confirmation: ''
			}
		}
	},
	beforeUnmount() {
		if (this.$refs.signup) {
			this.$validationReset(this.$refs.signup)
		}
		this.field = {
			first_name: '', last_name: '', email: '',
			phone: {code: '', number: '', country: ''},
			password: '', password_confirmation: ''
		}
	},
	methods: {
		_response(value = null) {
			store.commit('auth/SET_RESPONSE', value)
		},
		classes(index) {
			return store.getters['classes'](index)
		},
		cancel() {
			this._response(null)
			store.dispatch('auth/cancel')
		},
		signup(event) {
			if (this.loading) return;
			this.$validate(event).then(() => {
				this.loading = true
				this._response(null)
				return store.dispatch('auth/websignup', this.field)
			}).then((response) => {
				if (response === true) {
					store.dispatch('open').then(response => {
						this._response(null)
						store.commit('auth/SET_ACTIVE', null)
						store.commit('SET_PAGE', this.pages[1])
					})
				} else {
					this.field.password = ''
					this.field.password_confirmation = ''
					this.loading = false
				}
			})
		},
		signin() {
			store.commit('auth/SET_RESPONSE', null)
			store.commit('auth/SET_ACTIVE', 'websignin')
		},
		trans(key) {
			return store.getters.trans(key)
		}
	},
	components: {
		'field-phone': Phone,
		'field-password': Password
	}
}
</script>
